import './event-repeat-change-modal.style.sass';
import template from './event-repeat-change-modal.tpl.pug';

class EventRepeatChangeModalController {
    /* @ngInject */
    constructor(eventUtil) {
        this.eventUtil = eventUtil;

        this.onlyThisValue = this.eventUtil.EventRepeatSelector.OnlyThis;
        this.thisAndAllFollowingValue = this.eventUtil.EventRepeatSelector.ThisAndAllFollowing;

        this.selectOnlyThis();
    }

    get isOnlyThisSelected() {
        return this.selector === this.onlyThisValue;
    }

    selectOnlyThis() {
        this.selector = this.onlyThisValue;
    }

    selectThisAndAllFollowing() {
        this.selector = this.thisAndAllFollowingValue;
    }

    confirm() {
        return this.onClose({
            data: this.selector
        });
    }

    cancel() {
        return this.onDismiss();
    }
}

export default {
    selector: 'dbAEventRepeatChangeModal',
    template: template(),
    controller: EventRepeatChangeModalController,
    bindings: {
        onClose: '&',
        onDismiss: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/modals/component/event-repeat-change-modal/event-repeat-change-modal.cmpt.js